<template>
  <div>
    <div class="row full-width justify-end q-pr-md q-pt-md">
      <QBtn
        :style="`${showClosePage ? '' : 'visibility: hidden'}`"
        @click="$emit('close')"
        round
        flat
        active
        class="text-grey-6"
        style="font-size: 10px"
        ><i aria-hidden="true" role="img" class="q-icon eva eva-close-outline">
        </i
      ></QBtn>
    </div>
    <SAIUserProfileStepper
      class="full-height"
      :saving="saving"
      :name="name"
      :postcode-img="postcodeImg"
      :contact-img="contactImg"
      :loading="loading"
      :user-organisations="userOrganisations"
      :selected-organisation="selectedOrganisation"
      :user="user"
      :active-page="activePage"
      :errors="errors"
      :valid-pages="validPages"
      :can-skip="false"
      :display-dots="displayDots"
      @update:user="$emit('update:user', $event)"
      @update:organisation="$emit('update:organisation', $event)"
      @next="$emit('next', $event)"
      @skip="$emit('skip')"
      @update:page="$emit('update:page', $event)"
    >
      <SAIStep :name="contactUsKey">
        <SAIUserProfileStepContactUs :support-number="supportNumber" />
      </SAIStep>
    </SAIUserProfileStepper>
  </div>
</template>

<script>
import {
  SAIUserProfileStepper,
  SAIUserProfileStepContactUs,
  SAIStep
} from 'ecx.saigon.ui.common';
import { QBtn } from 'quasar';

export default {
  name: 'UserProfileStepper',
  props: {
    saving: Boolean,
    name: String,
    loading: Boolean,
    postcodeImg: String,
    contactImg: String,
    showClosePage: Boolean,
    selectedOrganisation: {
      type: Object,
      default: () => ({})
    },
    userOrganisations: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    activePage: {
      type: String,
      required: true
    },
    validPages: {
      type: Object,
      default: () => ({})
    },
    supportNumber: String,
    displayDots: {
      type: Boolean,
      default: true
    },
    contactUsKey: String
  },
  components: {
    SAIUserProfileStepper,
    SAIUserProfileStepContactUs,
    SAIStep,
    QBtn
  }
};
</script>
